<template>
  <div class="user-upload">
    <div class="right-wrapper">
      <div class="right-box" id="right">
        <form class="bk-form">
          <!-- 基础资料 -->
          <div class="upload-panel" id="anchor-1">
            <h4>基础资料</h4>
            <div class="upload-form">
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 作品类型：</label>

                <div class="bk-form-content">
                  <single-selector :list="sysTypeList" :setting-key="'id'" :selected.sync="baseInfo.sys_type_id" :disabled=true style="width: 168px; display: inline-block;">
                  </single-selector>
                </div>
              </div>
              <div class="bk-form-item" v-if="baseInfo.sys_type_id==1">
                <label class="bk-label">
                   <span class="bk-label-required">*</span>应用ID：
                </label>
                <div class="bk-form-content">
                  <input type="text" v-model="baseInfo.app_code" disabled class="bk-form-input"
                    style="width: 536px" maxlength="30">
                </div>
              </div>
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 功能类型：</label>
                <div class="bk-form-content">
                    <single-selector :list="funcTypeList" :setting-key="'id'" :selected.sync="baseInfo.func_type_id" :disabled=true style="width: 168px; display: inline-block;">
                    </single-selector>
                  </bk-selector>
                </div>
              </div>
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 作品名称：
                </label>
                <div class="bk-form-content" :class="isFieldWarning('name')">
                  <input type="text" v-model="baseInfo.name" class="bk-form-input"
                    name="validation_name" placeholder="此处输入你上传的作品名称，建议30个字符以内" style="width: 614px">
                  <span class="tips">{{check.name.tips}}</span>
                </div>
              </div>

              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 简要概述：</label>
                <div class="bk-form-content" :class="isFieldWarning('desc')">
                  <textarea v-model="baseInfo.desc" maxlength="50" class="bk-form-textarea"
                    name="validation_name" placeholder="请输入产品的详细介绍" style="width: 614px; min-height: 70px;"></textarea>
                  <span class="bk-form-number">{{baseInfo.desc.length}}</span>
                  <span class="tips">{{check.desc.tips}}</span>
                </div>
              </div>
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 作品介绍：</label>
                <div class="bk-form-content" :class="isFieldWarning('feature')">
                  <div style="width:614px">
                    <script type="text/plain" id="myEditor" style="width:614px;min-height:200px;">
                    </script>
                    <span class="tips">{{check.feature.tips}}</span>
                  </div>
                </div>
              </div>
              <div class="bk-form-item">
                <label class="bk-label">
                    体验地址：</label>
                <div class="bk-form-content" :class="isFieldWarning('test_url')">
                  <input type="text" v-model="baseInfo.test_url" @input="checkValidate('test_url')" class="bk-form-input" name="validation_name" placeholder="请在此处输入作品的线上体验地址，有助于用户直观的了解你的作品。"
                    style="width: 614px">
                  <span class="tips" style="left: 41%;">{{check.test_url.tips}}</span>
                </div>
              </div>
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 开发语言：</label>
                <div class="bk-form-content" id="language">
                  <selector :list="langList" :selected.sync="baseInfo.language_id" :multi-select="true"
                    :searchable="true" style="width: 614px"></selector>
                </div>
              </div>
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 浏览器兼容：</label>
                <div class="bk-form-content" id="browser">
                  <selector :list="browserList" :selected.sync="baseInfo.browser_id" :multi-select="true" :searchable="true"
                    style="width: 614px" ref="browser">
                  </selector>
                </div>
              </div>
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 部署环境：</label>
                <div class="bk-form-content" id="surroundings">
                  <selector :list="envList" :selected.sync="baseInfo.deploy_id" :multi-select="true"
                    :searchable="true" style="width: 614px">
                  </selector>
                </div>
              </div>
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 界面语言：</label>
                <div class="bk-form-content" id="interface">
                  <selector :list="i18nList" :selected.sync="baseInfo.i18n_id" :multi-select="true"
                    :searchable="true" style="width: 614px">
                  </selector>
                </div>
              </div>
              <div class="bk-form-item">
                <label class="bk-label">
                  <span class="bk-label-required">*</span> 分类标签：</label>
                  <div class="bk-form-content">
                    <tag :tags.sync="baseInfo.labels" placeholder="请输入不超过5个关键词作为标签，明确的关键词能够帮助用户更精准快速的定位到你的作品！"></tag>
                  </div>
              </div>
            </div>
            <div class="upload-action">
              <a :class="['bk-button', 'bk-primary',{'is-loading':saveFlag === false}]" id="submit" @click="save" title="提交">
                <span>提交</span>
              </a>
              <a class="bk-button bk-return" title="返回" @click="back">
                <span>返回</span>
              </a>
            </div>
          </div>


        </form>
      </div>
    </div>
    <!-- 弹出框子组件 -->
    <v-alert :options="options"></v-alert>
  </div>
</template>

<script type="text/javascript">
  import vAlert from '../../alert.vue'
  import tradingMode from '../works/trading_mode.vue'
  import selector from '../../selector/selector.vue'
  import singleSelector from '../../../components/selector/selector.vue'
  import tag from './tag.vue'

  export default {
    data() {
      return {
        ueditor: null,
        saveFlag: true, //提交按钮
        baseInfo: {
          name: '',
          sys_type_id: 0,
          desc: '',
          feature: '',
          language_id: [],
          browser_id: [],
          deploy_id: [],
          i18n_id: [],
          labels: [],
          test_url: ''
        },
        sysTypeList: [],
        funcTypeList: [],
        langList: [],
        browserList: [],
        envList: [],
        i18nList: [],
        check: {
          name: {
            isShow: false,
            tips: ''
          },
          sys_type_id: {
            isShow: false,
            tips: ''
          },
          desc: {
            isShow: false,
            tips: ''
          },
          feature: {
            isShow: false,
            tips: ''
          },
          test_url: {
            isShow: false,
            tips: ''
          }
        },
        options: {
          msgText: "",
          msgIsSuccess: true
        },
        warningFields: []
      }
    },
    created() {
      this.getSelectedList();
      this.getBasicInfo();
    },
    mounted() {
      this.initEditor();
    },
    methods: {
      initEditor(){
        if (UM.getEditor('myEditor') && UM.getEditor('myEditor').destroy) {
          UM.getEditor('myEditor').destroy();
        }

        this.ueditor = UM.getEditor('myEditor');
      },
      back () {
        window.history.go(-1)
      },
      /*
       ** 获取默认列表
       */
      getSelectedList() {
        axios.get(myUrl + 'core/product/labels/').then((res) => {
          let resData = res.data;
          if (resData.result) {
            this.sysTypeList = resData.data.sys_choices; // 基础资料 -> 作品类型
            this.funcTypeList = resData.data.func_choices; // 基础资料 -> 作品类型
            this.langList = resData.data.lbl_dev_lang; // 上传作品文件 -> 开发语言
            this.browserList = resData.data.lbl_browser; // 上传作品文件 -> 浏览器兼容
            this.envList = resData.data.lbl_env; // 上传作品文件 -> 部署环境
            this.i18nList = resData.data.lbl_i18n; // 上传作品文件 -> 界面语言
          } else {
            // 错误提示
            this.options = {
              msgIsSuccess: false,
              msgText: res.message
            }
          }
        })
      },
      decodeHtml (html) {
        html = html.replace(/&amp;/ig, '&')
        html = html.replace(/&lt;/ig, '<')
        html = html.replace(/&gt;/ig, '>')
        html = html.replace(/&nbsp;/ig, ' ')
        html = html.replace(/&quot;/ig, '"')
        html = html.replace(/&#39;/ig, "'")
        return html
      },
      /*
       ** 获取产品信息
       */
      getBasicInfo () {
        const app_id = this.$route.params.wid;

        axios.get(myUrl + `core/product/info/${app_id}/`, {
          params: {
            keyword: 'basic'
          }
        }).then((res) => {
          if (res.data.result) {
            let resData = res.data.data.app_basic;
            this.baseInfo.feature = resData.feature;
            this.baseInfo = Object.assign({}, this.baseInfo, resData)
            UM.getEditor('myEditor').setContent(this.baseInfo.feature,"");
          } else {
            this.options = {
              msgIsSuccess: false,
              msgText: res.data.message
            }
          }
        })
      },
      /*
       ** 从指定数组中删除元素
       */
      removeItem (item, array) {
        array.find((el, index) => {
          if (el == item) {
            array.splice(index, 1);
            console.log(array)
            return;
          }
        });
      },
      /*
       ** 检查当前项是否在错误数组中
       */
      isFieldWarning (str) {
        if (this.warningFields.indexOf(str) > -1) {
          return {
            warning: true
          }
        } else {
          return {
            warning: false
          }
        }
      },
      /*
      /*
       ** 验证输入合法性
       */
      checkValidate(type) {
        let baseInfo = this.baseInfo;
        let files = this.files;
        let validateState = false;
        switch (type) {
          case 'baseInformation.appID':
            if (!(/^[A-Za-z][A-Za-z0-9|-]{2,15}$/).test(this.baseInformation.appID.value)) {
              this.baseInformation.appID.isShow = true;
              this.baseInformation.appID.tips = "由小写英文字母，连接符(-)或数字组成，长度为3~16个字符，并且以字母开头";
              validateState = true;
            }
          break;
          // case 'name':
          //   if (!(/^[\u4e00-\u9fa5]{4,8}$/).test(baseInfo.name)) {
          //     this.check.name.isShow = true;
          //     this.check.name.tips = "请输入合法作品名称（4~8个中文字符）";
          //     validateState = true;
          //   }
          //   break;

          // case 'desc':
          //   if (!(/^[\u4e00-\u9fa5]{1,50}$/).test(baseInfo.desc)) {
          //     this.check.desc.isShow = true;
          //     this.check.desc.tips = "请输入合法简要概述（50个中文字符以内）"
          //     validateState = true;
          //   }
          //   break;

          // case 'feature':
          //   if (!baseInfo.feature.length) {
          //     this.check.feature.isShow = true;
          //     this.check.feature.tips = "请输入合法功能点描述（5000个字符以内）";
          //     validateState = true;
          //   }
          //   break;

          case 'test_url':
            if (!baseInfo.test_url){
              this.check.test_url.isShow = false;
              break;
            }
            let urlReg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?/
            if (!urlReg.test(baseInfo.test_url)) {
              this.check.test_url.isShow = true;
              this.check.test_url.tips = "请输入合法的体验地址";
              validateState = true;
            }
            break;
        }

        if (validateState) {
          if (this.warningFields.indexOf(type) === -1) {
            this.warningFields.push(type);
          }
        } else {
          this.removeItem(type, this.warningFields);
        }
      },
      validate() {
        let warningFields = this.warningFields;
        if (warningFields.length) {
          window.scrollTo(0, 0);
          return false;
        }
        return true
      },
      checkParams (params) {
        // return true
        if (params.name.length < 4 || params.name.length > 20) {
          this.options = {
            msgText: '请输入作品名称',
            msgIsSuccess: false
          }
          this.check.name.isShow = true;
          this.check.name.tips = "请输入合法作品名称（4~8个中文字符）";
          return false
        }

        if (!params.desc) {
          this.options = {
            msgText: '请输入简要概述',
            msgIsSuccess: false
          }
          return false
        }

        if (!params.feature) {
          this.options = {
            msgText: '请输入功能点描述',
            msgIsSuccess: false
          }
          return false
        }

        if (params.lang  === '[]') {
          this.options = {
            msgText: '请选择开发语言',
            msgIsSuccess: false
          }
          return false
        }

        if (params.browser  === '[]') {
          this.options = {
            msgText: '请选择浏览器兼容',
            msgIsSuccess: false
          }
          return false
        }

        if (params.env  === '[]') {
          this.options = {
            msgText: '请选择部署环境',
            msgIsSuccess: false
          }
          return false
        }

        if (params.i18n  === '[]') {
          this.options = {
            msgText: '请选择界面语言',
            msgIsSuccess: false
          }
          return false
        }

        if (params.tags  === '[]') {
          this.options = {
            msgText: '请设置分类标签',
            msgIsSuccess: false
          }
          return false
        }
        if (params.sys_type == 1 && !params.appID) {
          this.options = {
            msgText: '请输入应用ID',
            msgIsSuccess: false
          }
          this.baseInformation.name.isShow = true;
          this.baseInformation.name.tips = "由小写英文字母，连接符(-)或数字组成，长度为3~16个字符，并且以字母开头";
          return false
        }

        return true
      },
      /*
       ** 提交保存
       */
      save() {
        this.saveFlag = false;
        setTimeout(() => {
          this.saveFlag = true
        }, 5000)
        if (!this.validate()) {
          return true;
        } else {
          let baseInformation = this.baseInformation;
          let workId = this.$route.params.wid
          let files = this.files
          let baseInfo = this.baseInfo

          let params = {
            keyword: 'basic',
            name: baseInfo.name,
            func_type: baseInfo.func_type_id,
            sys_type: baseInfo.sys_type_id,
            desc: baseInfo.desc,
            feature: UM.getEditor('myEditor').getContent(),
            test_url: baseInfo.test_url,
            lang: JSON.stringify(baseInfo.language_id),
            browser: JSON.stringify(baseInfo.browser_id),
            env: JSON.stringify(baseInfo.deploy_id),
            i18n: JSON.stringify(baseInfo.i18n_id),
            tags: JSON.stringify(baseInfo.labels),
            appID: baseInfo.app_code
          }

          if (this.checkParams(params)) {
            axios.post(myUrl + `core/product/update/${workId}/`, qs.stringify(params)).then((response) => {
              let res = response.data
              if (res.result) {
                this.saveFlag = true;
                this.options = {
                  msgIsSuccess: true,
                  msgText: '更新成功'
                };
              } else {
                this.options = {
                  msgIsSuccess: false,
                  msgText: res.message
                };
              }
            }, reject => {
              this.options = {
                msgText: reject.message,
                msgIsSuccess: false
              }
            })
          }
        }
      }
    },
    components: {
      tradingMode,
      vAlert,
      selector,
      singleSelector,
      tag
    }
  }
</script>

<style media="screen" lang="scss">
  .user-upload {
    .bk-button {
      float: none;
      &.bk-primary,
      &.bk-return {
        width: 93px;
        margin-right: 10px;
      }
    }
    .app-detail {
      .icon-upper {
        width: 7px;
        height: 12px;
        display: inline-block;
        background: url(../../../images/personal_center/icon-left.png) no-repeat;
        background-size: cover;
        margin: 25px 0;
      }
    }
  }

  .bk-personal_center {
    .user-upload {
      .bk-form {
        margin-left: 0;
        margin-right: 0;
        position: relative;
        .bk-label {
          position: relative;
          font-size: 14px;
          color: #a6a6a6;
          padding: 13px 28px 13px 0;
          .bk-label-required {
            width: 5px;
            height: 6px;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 14px;
            letter-spacing: 0px;
            color: #ff6600;
          }
        }

        .bk-form-item {
          &:first-child {
            margin-top: 0;
            line-height: 36px;
          }
          &:nth-child(4) {
            .basic-textarea {
              width: 756px;
              height: 60px;
              background-color: #ffffff;
              border-radius: 2px;
              border: solid 1px #c3cdd7;
              line-height: 58px;
              padding: 0 10px;
            }
          }
          &:last-child {
            .bootstrap-tagsinput {
              width: 614px;
              min-height: 38px;

              line-height: 36px;
              padding: 0 10px;
              .tag.label.label-info {
                display: inline-block;
                height: 22px;
                line-height: 20px;
                padding: 0 10px;
                margin-right: 5px;
                margin-bottom: 5px;
                background-color: #fafafa;
                border-radius: 2px;
                border: solid 1px #e6e6e7;
                color: #888991;
                font-size: 12px;
                input[type="text"] {
                  border: 0px;
                }
              }
            }
          }

          .tag-content {
            width: 614px;
            border: solid 1px #e6e6e7;
            padding-top: 7px;
            display: table;
            -webkit-transition: border .35s;
            transition: border .35s;
          }
          .bk-form-tag {
            display: inline-block;
            padding: 0 9px;
            line-height: 20px;
            height: 22px;
            border: solid 1px #e6e6e7;
            background: #fafafa;
            margin: 0 0 7px 5px;
            float: left;
          }
        }
        .upload-form {
          padding: 40px 20px;
        }
        .upload-action {
          display: table;
          padding: 0 30px 60px 168px;
        }
        /* .bk-form-input,
        .bk-form-password,
        .bk-form-select, */
        /* .bk-form-textarea {
          color: #4f515e;
        } */
      }
    }
  }
</style>
<style media="screen" lang="scss" scoped>
  .icon-attention {
    width: 16px;
    height: 16px;
    position: relative;
    top: 5px;
    margin-left: 5px;
    display: inline-block;
    background: url(../../../images/application_detail/icon-info.png) no-repeat;
  }

  .app-detail {
    width: 100%;
    height: 60px;
    background: #fff;
    margin-bottom: 10px;
    .app-link {
      display: inline-block;
      width: 27px;
      height: 60px;
      text-align: center;
      border-right: solid 1px #f4f4f4;
    }
    .app {
      padding: 11px 8px;
      width: 221px;
      float: right;
      height: 60px;
      span {
        line-height: 38px;
        max-width: 157px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        padding-left: 10px;
        font-size: 16px;
        color: #888991;
        font-weight: bold;
      }
      .app-img {
        width: 38px;
        height: 38px;
        display: inline-block;
        float: left;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .process {
    display: inline-block;
    font-style: normal;
    background: #f4f4f4;
    text-align: center;
    width: 24px;
    height: 24px;
    line-height: 24px;
    margin-right: 10px;
    color: #a6a6a6;
    border-radius: 50%;
    font-size: 16px;
    font-weight: bold;
  }

  .upload-panel {
    border-bottom: 4px solid #f4f4f4;
    h4 {
      padding: 18px 0;
      font-size: 18px;
      font-weight: bold;
      color: #77787f;
      border-bottom: 1px solid #f4f4f4;
      margin: 15px 45px 0 45px;
    }
  }

  .upload-file {
    position: relative;
    text-align: left;
    line-height: 36px;
    .bk-form-input {
      padding: 0;
      line-height: 36px;
      width: 96px;
      text-align: center;
      float: left;
    }
    .bk-form-tips {
      display: inline-block;
      color: #4f515e;
      padding-left: 30px;
    }
    input[type='file'] {
      opacity: 0;
      position: absolute;
      left: 0;
      top: 0;
      width: 96px;
      height: 36px;
    }
  }

  .bk-form-number {
    display: inline-block;
    line-height: 36px;
    color: #a6a6a6;
    padding-left: 5px;
  }

  .bk-form-content {
    position: relative;
  }

  .tips {
    background: #090b1a;
    position: absolute;
    white-space: nowrap;
    color: #fff;
    top: -40px;
    left: 50%;
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    border-radius: 2px;
    text-align: center;
    transform: translateX(-50%);
    -o-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    &:after {
      content: '';
      position: absolute;
      left: 50%;
      bottom: -14px;
      width: 0;
      height: 0;
      border: 10px solid #090b1a;
      border-color: #090b1a transparent transparent transparent;
      margin-left: -10px;
    }
  }

  .bk-upload-ul {
    margin-top: 5px;
    .bk-list-li {
      height: 60px;
      border: 1px solid #e6e6e7;
      border-radius: 2px;
      padding: 15px;
      width: 380px;
      display: inline-block;
      .icon-file-zip {
        display: inline-block;
        width: 30px;
        height: 30px;
        background: url(../../../images/application_detail/icon-file-zip.png) no-repeat;
        margin-right: 10px;
        top: -10px;
      }
      .bk-list-content {
        vertical-align: top;
        top: -10px;
        width: 300px;
        float: right;
        position: relative;
        .bk-load {
          position: absolute;
          bottom: 0;
          width: 100%;
          left: 0;
          height: 4px;
          background: #e6e6e7;
          display: inline-block;
          border-radius: 2px;
          >span {
            position: absolute;
            bottom: 0;
            left: 0;
            height: 3px;
            width: 0;
            background: #57a3f1;
            -webkit-transition: all .5s;
            -moz-transition: all .5s;
            -ms-transition: all .5s;
            transition: all .5s;
          }
          .loading {
            width: 90%;
          }
          .totalLoading {
            width: 100%;
          }
        }
        .name {
          width: 100%;
          display: inline-block;
          height: 40px;
        }
        span {
          line-height: 40px;
          color: #888991;
        }
        .icon-close {
          position: absolute;
          right: 0;
          cursor: pointer;
          top: 13px;
          left: auto;
          font-size: 12px;
        }
        .icon-check-1 {
          position: absolute;
          right: 0;
          cursor: pointer;
          top: 13px;
          left: auto;
          color: #5bd18b;
          font-size: 12px;
        }
      }
    }
  }
  .tips {
    display: none;
  }
  .warning .tips {
    z-index:100000;
    display: block;
    background: #090b1a;
    position: absolute;
    white-space: nowrap;
    color: #fff;
    top: -40px;
    left: 50%;
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    border-radius: 2px;
    text-align: center;
    transform: translateX(-50%);
    -o-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    &:after {
      content: '';
      position: absolute;
      left: 50%;
      bottom: -14px;
      width: 0;
      height: 0;
      border: 10px solid #090b1a;
      border-color: #090b1a transparent transparent transparent;
      margin-left: -10px;
    }
  }
</style>



// WEBPACK FOOTER //
// basic_information.vue?52fbedec